<div id="outer" class="well container">
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">FIN Report</div>
    </div>
    <div class="col-md-12 well-content">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs" id="infoTabs" role="tablist">
            <li role="presentation" [class.active]="activeTab === 'general'">
                <a (click)="activeTab = 'general'" role="tab" style="cursor: pointer">New Report</a>
            </li>
            <li role="presentation" [class.active]="activeTab === 'jobs'">
                <a (click)="activeTab = 'jobs'" role="tab" style="cursor: pointer"
                    >Jobs<span style="margin-left: 4px" [innerText]="RunningReports" class="badge"></span
                ></a>
            </li>
        </ul>
        <!-- Tab panes -->
        <div class="tab-content" style="padding-top: 20px">
            <div role="tabpanel" class="tab-pane" id="general" [class.active]="activeTab === 'general'">
                <form>
                    <div style="margin-top: 10px; margin-bottom: 30px">
                        <div class="row">
                            <div class="col-sm-offset-2 col-sm-4">
                                <div class="arHead">1) Select Date Range</div>
                                <div style="margin-top: 5px"></div>
                                <span>Start Date</span>
                                <div style="margin-top: 5px"></div>
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.StartDate"
                                    id="startDate"
                                    type="text"
                                    class="form-control"
                                    placeholder="yyyy-mm-dd" />
                                <span>End Date</span>
                                <div style="margin-top: 5px"></div>
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.EndDate"
                                    id="endDate"
                                    type="text"
                                    class="form-control"
                                    placeholder="yyyy-mm-dd" />
                            </div>
                            <div class="col-sm-4">
                                <div class="arHead">3) Select Options</div>
                                <div style="margin-top: 5px"></div>
                                Copies
                                <div style="margin-top: 5px"></div>
                                <input
                                    id="copies"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.Copies"
                                    class="form-control"
                                    type="number"
                                    value="1" />
                                <div style="margin-top: 5px"></div>
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.PartsInvoice"
                                    type="checkbox" />Equip - Parts Invoice<br />
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.ServiceInvoice"
                                    type="checkbox" />Equip - Service Invoice<br />
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.RentalInvoice"
                                    type="checkbox" />Equip - Rental Invoice<br />
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.SalesInvoice"
                                    type="checkbox" />Equip - Sales Invoice<br />
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.AdjustmentNote"
                                    type="checkbox" />Equip - Adjustment Note<br />
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.PartsCreditMemo"
                                    type="checkbox" />Equip - Parts Credit Memo<br />
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.ServiceCreditMemo"
                                    type="checkbox" />Equip - Service Credit Memo<br />
                            </div>
                        </div>
                        <div style="margin-top: 15px"></div>
                        <div class="row">
                            <div class="col-sm-offset-2 col-sm-4">
                                <div class="arHead">2) Select Customers</div>
                                <div style="margin-top: 5px"></div>
                                <input
                                    type="radio"
                                    name="runType"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.RunType"
                                    id="customNumType"
                                    value="customerNumber" /><label for="customNumType">Customer Number</label>
                                <input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.CustomerNumber"
                                    id="customerNumber"
                                    type="number"
                                    class="form-control" />
                                <input
                                    type="radio"
                                    name="runType"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.RunType"
                                    id="customRangeType"
                                    value="customerRange" /><label for="customRangeType">Customer Range:</label><br />
                                Minimum Customer Number<input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.MinCustomerNumber"
                                    id="minCustomerNumber"
                                    class="form-control"
                                    type="number" />
                                <div style="margin-top: 5px"></div>
                                Maximum Customer Number<input
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.MaxCustomerNumber"
                                    id="maxCustomerNumber"
                                    class="form-control"
                                    type="number" />
                                <div style="margin-top: 5px"></div>
                                <input
                                    type="radio"
                                    name="runType"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.RunType"
                                    id="customListType"
                                    value="customerList" /><label for="customListType">Customer List:</label>
                                <select
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="ReportInfo.SelectedCustomers"
                                    style="width: 100%; margin-top: 5px"
                                    multiple="multiple">
                                    @for (item of FINData?.CustomerList; track item) {
                                        <option [ngValue]="item">
                                            {{ item }}
                                        </option>
                                    }
                                </select>
                                <br />
                                <button
                                    type="button"
                                    class="btn btn-default"
                                    style="width: 100%; margin-top: 5px"
                                    (click)="removeCustomer()">
                                    Remove Selected
                                </button>
                                <div class="input-group" style="margin-top: 5px">
                                    <input
                                        class="form-control"
                                        type="text"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="ReportInfo.NewCustomerNum"
                                        id="customerInput"
                                        placeholder="Customers" />
                                    <span class="input-group-btn"
                                        ><button type="button" class="btn btn-default" (click)="addCustomer()">
                                            Add
                                        </button></span
                                    >
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="arHead">4) Run Report</div>
                                <div style="margin-top: 25px"></div>
                                <button (click)="RunPrintReport(ReportInfo)" class="btn btn-default">
                                    Print Invoices
                                </button>
                            </div>
                        </div>
                        <div class="row"></div>
                    </div>
                </form>
            </div>
            <div role="tabpanel" class="tab-pane" id="jobs" [class.active]="activeTab === 'jobs'">
                @if (Jobs == null || Jobs.length < 1) {
                    <table id="scanTable">
                        <tbody>
                            <tr style="height: 100px">
                                <td>
                                    <span style="color: darkgray">No jobs found.</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                }
                @if (Jobs != null && Jobs.length > 0) {
                    <table id="scanTable" class="one-column-emphasis">
                        <thead>
                            <tr>
                                <th style="width: 45px; padding: 0">
                                    @if (Jobs != null) {
                                        <button
                                            title="Refresh"
                                            class="btn btn-default"
                                            style="font-size: 12px"
                                            (click)="Refresh()">
                                            <span style="color: green" class="fa-solid fa-arrows-rotate"></span>
                                        </button>
                                    }
                                    &nbsp;
                                </th>
                                <th>Time Requested</th>
                                <th>Time Finished</th>
                                <th>Date Range</th>
                                <th>Customer(s)</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (Job of Jobs; track Job) {
                                <tr style="height: 50px">
                                    <td style="width: 45px; padding: 0">
                                        @if (Job.JobParams != null && Job.JobParams !== "") {
                                            <button
                                                title="Job Information"
                                                class="btn btn-default"
                                                style="font-size: 12px"
                                                (click)="ShowJobInfo(modalJobInfo, Job)">
                                                <span style="color: #5f94d7" class="fa-solid fa-circle-info"></span>
                                            </button>
                                        }
                                        &nbsp;
                                    </td>
                                    <td>
                                        <span>{{ Job.JobCreateTime | date: "M/d/yyyy h:mm:ss a" }}</span>
                                    </td>
                                    <td>
                                        @if (Job.JobEndTime != null && Job.JobEndTime !== "") {
                                            <span>{{ Job.JobEndTime | date: "M/d/yyyy h:mm:ss a" }}</span>
                                        }
                                        @if (Job.JobEndTime == null || Job.JobEndTime === "") {
                                            <span>Processing...</span>
                                        }
                                    </td>
                                    <td>
                                        Start: <span [innerText]="Job.JobParams.StartDate"></span> /<br />
                                        End: <span [innerText]="Job.JobParams.EndDate"></span>
                                    </td>
                                    <td>
                                        @if (Job.JobParams.RunFromList) {
                                            <span> Customer List </span>
                                        }
                                        @if (
                                            Job.JobParams.MaxCustomerNumber != null &&
                                            Job.JobParams.MinCustomerNumber != null
                                        ) {
                                            <span>
                                                #<span [innerText]="Job.JobParams.MinCustomerNumber"></span
                                                >&nbsp;-&nbsp;#<span
                                                    [innerText]="Job.JobParams.MaxCustomerNumber"></span>
                                            </span>
                                        }
                                        @if (Job.JobParams.CustomerNumber != null) {
                                            <span> #<span [innerText]="Job.JobParams.CustomerNumber"></span> </span>
                                        }
                                    </td>
                                    <td>
                                        @if (Job.JobCompleteFile != null && Job.JobCompleteFile !== "") {
                                            <span
                                                ><button
                                                    class="btn btn-blue"
                                                    style="font-size: 12px"
                                                    (click)="DownloadFile(Job)">
                                                    Download
                                                </button></span
                                            >
                                        }
                                        @if (
                                            (Job.JobCompleteFile == null || Job.JobCompleteFile === "") &&
                                            Job.JobEndTime != null &&
                                            Job.JobEndTime !== ""
                                        ) {
                                            <span
                                                ><button
                                                    class="btn btn-blue"
                                                    style="font-size: 12px"
                                                    (click)="ShowJobLog(modalJobLog, Job)">
                                                    View Log
                                                </button></span
                                            >
                                        }
                                        @if (Job.JobCompleted) {
                                            <span
                                                ><button
                                                    style="font-size: 12px"
                                                    (click)="DeleteJob(Job)"
                                                    class="btn btn-default">
                                                    <i class="fa-solid fa-trash"></i></button
                                            ></span>
                                        }
                                        @if (
                                            (Job.JobEndTime == null || Job.JobEndTime === "") &&
                                            Job.JobStartTime != null &&
                                            Job.JobStartTime !== ""
                                        ) {
                                            <span
                                                ><button
                                                    class="btn btn-blue"
                                                    style="font-size: 12px"
                                                    (click)="ShowJobProgress(modalJobParams)">
                                                    View Progress
                                                </button></span
                                            >
                                        }
                                        @if (
                                            (Job.JobEndTime == null || Job.JobEndTime === "") &&
                                            (Job.JobStartTime == null || Job.JobStartTime === "")
                                        ) {
                                            <span>Queued</span>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
                @if (Jobs != null && Jobs.length > 0) {
                    <div class="col-md-12" style="margin-top: 10px">
                        <div class="row">
                            <div class="col-md-12">
                                Page {{ Page }} of {{ PageTotal == 0 ? 1 : PageTotal }} ({{ Results }} total)
                                <div class="pull-right">
                                    Display:
                                    <select
                                        class="form-control cmd-button small-select"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="PageSize"
                                        (ngModelChange)="DisplayChanged()">
                                        @for (opt of DisplayOptions; track opt) {
                                            <option [ngValue]="opt">
                                                {{ opt }}
                                            </option>
                                        }
                                    </select>
                                    @if (Page > 1) {
                                        <button
                                            (click)="GoBack()"
                                            type="button"
                                            style="font-size: 12px"
                                            class="btn btn-default cmd-button small-btn">
                                            Back
                                        </button>
                                    }
                                    @if (Page < PageTotal) {
                                        <button
                                            (click)="GoNext()"
                                            type="button"
                                            style="font-size: 12px"
                                            class="btn btn-default cmd-button small-btn">
                                            Next
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <ng-template #modalJobParams>
        <div class="modal-header">Status</div>
        <div class="modal-body">
            <form role="form">
                @if (ReportStatus.ReportDone != true) {
                    <table style="width: 100%; text-align: left; font-size: 15px; margin-top: 10px">
                        <tr>
                            <td style="width: 50%">Documents Processed</td>
                            <td style="width: 50%">
                                {{ ReportStatus.DocumentsDone }}
                                &nbsp;&nbsp;/&nbsp;&nbsp;
                                {{ ReportStatus.DocumentsTodo }}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%">Report Type</td>
                            <td>
                                {{ ReportStatus.ReportType }}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%">Currently</td>
                            <td>
                                {{ ReportStatus.StatusText }}
                            </td>
                        </tr>
                        <tr></tr>
                        <tr>
                            <td>Statement Date</td>
                            <td>
                                {{ ReportStatus.ReportDate }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <button
                                    style="width: 100%; margin-top: 5px; margin-bottom: 5px"
                                    class="btn btn-default"
                                    id="stopButton">
                                    Stop
                                </button>
                            </td>
                        </tr>
                    </table>
                }
                @if (ReportStatus.ReportDone != true) {
                    <nz-progress [nzPercent]="ProgressPercent"></nz-progress>
                }
                @if (ReportStatus.ReportDone) {
                    <div>
                        No running reports found. If you queued a report, the report job might take a few seconds to
                        start.
                        <br />
                    </div>
                }
            </form>
        </div>
    </ng-template>

    <ng-template #modalJobLog>
        <div class="modal-header">Job Log</div>
        <div class="modal-body">
            <form role="form">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search..."
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="JobLogFilter.Search" />
                @if (JobLogs == null || JobLogs.length < 1) {
                    <div style="color: #808080; margin-top: 15px">No logs found.</div>
                }
                @if (JobLogs != null && JobLogs.length > 0) {
                    <div style="max-height: 450px; width: 100%; overflow: hidden; overflow-y: scroll; margin-top: 15px">
                        <table class="table" style="width: 100%; text-align: left; font-size: 15px; margin-top: 10px">
                            @for (JobLog of JobLogs | filter: JobLogFilter.Search; track JobLog) {
                                <tr>
                                    <td>
                                        {{ JobLog.Message }}
                                    </td>
                                    <td>
                                        @if (JobLog.HasFile) {
                                            <button
                                                class="btn btn-blue"
                                                style="font-size: 12px"
                                                (click)="ViewJobLogFile(JobLog)">
                                                View File
                                            </button>
                                        }
                                        @if (!JobLog.HasFile) {
                                            <button class="btn btn-default" disabled="disabled" style="font-size: 12px">
                                                No File
                                            </button>
                                        }
                                    </td>
                                </tr>
                            }
                        </table>
                    </div>
                }
            </form>
        </div>
    </ng-template>
    <ng-template #modalJobInfo>
        <div class="modal-header">Job Information</div>
        <div class="modal-body">
            <form role="form">
                <table style="width: 100%; text-align: left; font-size: 15px; margin-top: 10px">
                    <tr>
                        <td style="width: 50%">Statement Date</td>
                        <td style="width: 50%">
                            {{ CurrentJob.JobParams.StatementDate }}
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%">Copies</td>
                        <td style="width: 50%">
                            {{ CurrentJob.JobParams.Copies == 0 ? "Default" : CurrentJob.JobParams.Copies }}
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%">Report Type</td>
                        <td style="width: 50%">
                            {{ CurrentJob.JobParams.Email ? "Email" : "Print" }}
                        </td>
                    </tr>
                    @if (CurrentJob.JobParams.MinCustomerNumber) {
                        <tr>
                            <td style="width: 50%">Min Customer Number</td>
                            <td style="width: 50%">
                                {{ CurrentJob.JobParams.MinCustomerNumber }}
                            </td>
                        </tr>
                    }
                    @if (CurrentJob.JobParams.MaxCustomerNumber) {
                        <tr>
                            <td style="width: 50%">Max Customer Number</td>
                            <td style="width: 50%">
                                {{ CurrentJob.JobParams.MaxCustomerNumber }}
                            </td>
                        </tr>
                    }
                    @if (CurrentJob.JobParams.CustomerNumber) {
                        <tr>
                            <td style="width: 50%">Single Customer Number</td>
                            <td style="width: 50%">
                                {{ CurrentJob.JobParams.CustomerNumber }}
                            </td>
                        </tr>
                    }
                    @if (CurrentJob.JobCreateTime) {
                        <tr>
                            <td style="width: 50%">Create Time</td>
                            <td style="width: 50%">
                                {{ CurrentJob.JobCreateTime | date: "M/d/yyyy h:mm:ss a" }}
                            </td>
                        </tr>
                    }
                    @if (CurrentJob.JobStartTime) {
                        <tr>
                            <td style="width: 50%">Start Time</td>
                            <td style="width: 50%">
                                {{ CurrentJob.JobStartTime | date: "M/d/yyyy h:mm:ss a" }}
                            </td>
                        </tr>
                    }
                    @if (CurrentJob.JobEndTime) {
                        <tr>
                            <td style="width: 50%">End Time</td>
                            <td style="width: 50%">
                                {{ CurrentJob.JobEndTime | date: "M/d/yyyy h:mm:ss a" }}
                            </td>
                        </tr>
                    }
                    <tr>
                        <td style="width: 50%">Completed</td>
                        <td style="width: 50%">
                            {{ CurrentJob.JobCompleted ? "Yes" : "No" }}
                        </td>
                    </tr>
                </table>
                <nz-progress [nzPercent]="ProgressPercent"></nz-progress>
            </form>
        </div>
    </ng-template>
    <ng-template #modalReportStatus>
        <div class="modal-header">Status</div>
        <div class="modal-body">
            <form role="form">
                <table style="width: 100%; text-align: left; font-size: 15px; margin-top: 10px">
                    <tr>
                        <td style="width: 50%">Documents Processed</td>
                        <td style="width: 50%">
                            {{ ReportStatus.DocumentsDone }}
                            &nbsp;&nbsp;/&nbsp;&nbsp;
                            {{ ReportStatus.DocumentsTodo }}
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%">Report Type</td>
                        <td>
                            {{ ReportStatus.ReportType }}
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%">Currently</td>
                        <td>
                            {{ ReportStatus.StatusText }}
                        </td>
                    </tr>
                    <tr></tr>
                    <tr>
                        <td>Statement Date</td>
                        <td>
                            {{ ReportStatus.ReportDate }}
                        </td>
                    </tr>
                </table>
                <nz-progress [nzPercent]="ProgressPercent"></nz-progress>
            </form>
        </div>
    </ng-template>
</div>
